/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { addDependencies } from './dependenciesAdd.generated.js';
import { divideDependencies } from './dependenciesDivide.generated.js';
import { factorialDependencies } from './dependenciesFactorial.generated.js';
import { isIntegerDependencies } from './dependenciesIsInteger.generated.js';
import { isPositiveDependencies } from './dependenciesIsPositive.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createMultinomial } from '../../factoriesAny.js';
export var multinomialDependencies = {
  addDependencies,
  divideDependencies,
  factorialDependencies,
  isIntegerDependencies,
  isPositiveDependencies,
  multiplyDependencies,
  typedDependencies,
  createMultinomial
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesMultinomial.generated.js
// module id = lC7/
// module chunks = 3